export default "__VITE_ASSET__BnDuovSF__"